import _ from 'lodash';
import classnames from 'classnames';
import * as React from 'react';

import { withTranslation, WithTranslation } from 'react-i18next';

import { isNumberValid, normalize, formatPhone } from '../../utils/phoneNumber';

import defaultStyles from '../../styles/formSetStyles.module.css';

interface Props extends WithTranslation {
  value: string;
  label: string;
  className?: string;
  disabled?: boolean;
  id?: string;
  placeholder?: string;
  updateFieldValue: (value: string) => void;
  saveFieldValue: (value: string) => void;
}

interface State {
  phoneNumber: string;
  validPhone: boolean;
}

class PhoneInput extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    const formattedPhone = formatPhone(props.value);
    this.state = {
      phoneNumber: formattedPhone,
      validPhone: isNumberValid(formattedPhone),
    };
  }

  componentDidUpdate(prevProps: Readonly<Props>) {
    const { value } = this.props;
    if (prevProps.value !== value) {
      this.setState({
        phoneNumber: formatPhone(value),
      });
    }
  }

  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputNumber = event.target.value;
    const formattedPhone = formatPhone(inputNumber);
    const validPhone = isNumberValid(formattedPhone);
    this.setState({
      phoneNumber: formattedPhone,
      validPhone,
    });
    this.props.updateFieldValue(normalize(inputNumber));
  };

  handleBlur = () => {
    const { phoneNumber, validPhone } = this.state;

    if (validPhone) {
      const cleanPhone = normalize(phoneNumber);

      this.props.updateFieldValue(cleanPhone);
      this.props.saveFieldValue(cleanPhone);
    }
  };

  render() {
    const {
      id,
      placeholder,
      className = defaultStyles.Input,
      t,
      label,
      disabled = false,
    } = this.props;
    const { phoneNumber, validPhone } = this.state;

    return (
      <div>
        <div className={defaultStyles.InputWrapper}>
          <input
            id={id}
            className={classnames({
              [defaultStyles.Input]: true,
              [defaultStyles.Invalid]: !validPhone,
              [className]: true,
              [defaultStyles.CanBeDisabled]: true,
            })}
            value={phoneNumber}
            placeholder={placeholder || '(###) ###-####'}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            type="tel"
            disabled={disabled}
          />
        </div>
        {!validPhone && (
          <div className={defaultStyles.InvalidHint}>
            {_.capitalize(
              t('invalidInputError', {
                type: t('number'),
                label,
              }),
            )}
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(PhoneInput);
